<template>
  <div>
    <section
      v-if="dataIsChecking404"
      class="flex flex-col space-y-4 items-center justify-center"
      >
      <h1 class="mx-auto inline-block " v-text="t('holdingpattern')" />
      <div v-text="t('waitingtext')" />
      <UiProgressAircraft class="mx-auto !my-8"/>
    </section>

    <Blog
      v-if="!dataIsChecking404 && dataBlog"
      :model-value="dataBlog"
      @delete="methodLoadUrl(true)"
      />

    <section v-else v-show="!dataIsChecking404">
      <h1>404</h1>
      <div v-html="t('404.lost')" />

      <br>

      <div class="flex flex-wrap gap-4">
        <ui-link to="/">
          <ui-button :text="t('404.back')" class="flat flex-grow md:flex-initial" />
        </ui-link>
        <ui-button :text="t('404.gb')" class="dark flex-grow md:flex-initial" @click="$router.go(-1)"/>

        <ui-button
          v-if="user.is_admin"
          class="dark"
          text="Create blog page"
          @click="methodCreate"
          />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const { locale } = useI18n()

const { t } = useI18n({
  messages: {
    en:{
      'waitingtext':'ATC is checking your route ...',
      'holdingpattern': 'Holding Pattern',
      '404':{
        lost: '<strong>The request resource could not be found.</strong><div class="pb-4"></div>This means it has not been created yet, or it has been deleted or moved.',
        back: 'Back to the homepage',
        gb: 'One page back',
      }
    },
    de: {
      'waitingtext':'ATC klärt die Route ...',
      'holdingpattern': 'Warteschleife',
      '404':{
        lost: '<strong>Die angeforderte Ressource konnte nicht gefunden werden.</strong><div class="pb-4"></div>Das bedeutet, dass sie noch nicht erstellt wurde oder gelöscht oder verschoben wurde.',
        back: 'Zurück zur Startseite',
        gb: 'Eine Seite zurück',
      }
    },
    es: {
      'waitingtext':'ATC está comprobando tu ruta ...',
      'holdingpattern': 'Patrón de espera',
      '404':{
        lost: '<strong>El recurso solicitado no se pudo encontrar.</strong><div class="pb-4"></div>Esto significa que aún no se ha creado, o que se ha eliminado o movido.',
        back: 'Volver a la página de inicio',
        gb: 'Una página atrás',
      }
    },
    uk: {
      'waitingtext':'ATC перевіряє ваш маршрут ...',
      'holdingpattern': 'Тримання в повітрі',
      '404':{
        lost: '<strong>Запитуваний ресурс не знайдено.</strong><div class="pb-4"></div>Це означає, що його ще не створено або його було видалено чи переміщено.',
        back: 'Повернутися на головну',
        gb: 'Одна сторінка назад',
      }
    },
  }
} as any);

const router = useRouter();
const route = useRoute()
const dataHasChecked = ref<boolean>(false)

const {
  data: dataBlog,
  pending: dataIsChecking404
} = await useAsyncData('blog_'+locale.value, () => {
  console.log('[asyncdata] Load slug')

  let path = route.path

  if (path.startsWith('/' + locale.value)) {
    path = path.replace('/' + locale.value, '')
  }

  return api.get('blog/url', { url: path })
    .then((res: any) => {
      return res?.data?.data ?? null
    })
    .catch((err: any) => {
      api.parseError(err)
      return null
    })
}, {
  server: true,
})

const methodLoadUrl = (reset : boolean|null|undefined = false) => {
  let pathWithoutLocale = router.currentRoute.value.path

  // if locale is at the beginning of the path
  if (pathWithoutLocale.startsWith('/' + locale.value)) {
    pathWithoutLocale = pathWithoutLocale.replace('/' + locale.value, '')
  }

  if(!dataHasChecked.value || reset){
    dataHasChecked.value = true
    methodRenderBlog(pathWithoutLocale).then((blog) => {
      dataBlog.value = blog
    }).finally(() => {
      dataIsChecking404.value = false
    });
  }
}

const methodCreate = () => {
  methodCreateBlogForUrl(useRouter().currentRoute.value.path).then(() => {
    methodLoadUrl(true)
  })
}
</script>
